import styled from 'styled-components';

type LimitationRowProps = {
  isActive: boolean;
};

export const LimitationUsersOfRoleRow = styled('tr')<LimitationRowProps>`
  user-select: none;
  & > td {
    padding: ${({ isActive }) => (isActive ? 'inherit' : 0)};
  }
  :hover {
    background-color: initial !important;
  }
  // border-bottom: 1px solid lightgray;
`;

export const UserRoleBadges = styled('div')`
  & > * {
    margin-left: 0.5rem;
    margin-bottom: 0.5rem;
    display: inline-flex;
  }
`;

export const LimitationTitleCell = styled('div')`
  align-items: center;
  cursor: pointer;
  display: flex;
  /* chevron */
  & > svg {
    margin-left: 0.5rem;
  }
`;
